import FeelingsBoxInfo from "./FeelingsBoxInfo";

export default FeelingsBoxInfo;